import './DsmSectionContainer.css';

interface DsmSectionContainerProps {
  children: React.ReactNode;
  className?: string;
}

/**
 * Lightweight DSM scope for a section within a legacy palmetto-components page.
 *
 * Handles:
 * - data-theme="core" scope for DSM token resolution
 * - DSM font and smoothing styles scoped to this element
 *
 * Does NOT handle full-bleed backgrounds or page-level layout — use
 * DsmPageContainer when the entire page is DSM.
 */
export const DsmSectionContainer = ({ children, className }: DsmSectionContainerProps) => {
  return (
    <div className={`dsm-section-container${className ? ` ${className}` : ''}`} data-theme="core">
      {children}
    </div>
  );
};
